export enum DOWNLOAD_TYPES {
  QUESTION,
  QUESTIONDESC,
  SCOREGUIDE_KEY,
  SAMPLERESPONSES,
  PERFDATA,
  TESTONLY,
  TESTWITHSCORING,
  ITEMLIST,
}

export enum DOWNLOAD_FORM {
  HTML = 'HTML',
  PDF = 'PDF',
  WORD = 'WORD',
  EXCEL = 'EXCEL'
}